import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, InputNumber, Card, Row, Col, DatePicker } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';

export const DriverCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/drivers',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Yangi haydovchi">
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Shaxsiy ma'lumotlar"
                  help="Haydovchining shaxsiy ma'lumotlari. Bu ma'lumotlar ilovada ko'rinadi."
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label="To'liq ism"
                    help="Haydovchining to'liq ismi va familiyasi"
                  />
                }
                name="fullName"
                rules={[{ required: true, message: "Ismni kiriting" }]}
              >
                <Input placeholder="Ali Valiyev" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Telefon raqam"
                    help="Haydovchining telefon raqami. +998 bilan boshlanishi kerak."
                  />
                }
                name="phone"
                rules={[
                  { required: true, message: "Telefon raqamni kiriting" },
                  { pattern: /^\+998\d{9}$/, message: "Format: +998XXXXXXXXX" },
                ]}
              >
                <Input placeholder="+998901234567" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Tug'ilgan sana"
                    help="Haydovchining tug'ilgan sanasi. 18 yoshdan katta bo'lishi kerak."
                  />
                }
                name="birthDate"
              >
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder="Sanani tanlang"
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Avtomobil ma'lumotlari"
                  help="Haydovchining asosiy avtomobili haqida ma'lumotlar. Keyinchalik boshqa avtomobillar qo'shish mumkin."
                />
              }
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label="Rusumi"
                        help="Avtomobil rusumi (brendi). Masalan: Chevrolet, Daewoo, Hyundai"
                      />
                    }
                    name="vehicleMake"
                    rules={[{ required: true, message: "Rusumni kiriting" }]}
                  >
                    <Input placeholder="Chevrolet" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label="Modeli"
                        help="Avtomobil modeli. Masalan: Cobalt, Nexia, Sonata"
                      />
                    }
                    name="vehicleModel"
                    rules={[{ required: true, message: "Modelni kiriting" }]}
                  >
                    <Input placeholder="Cobalt" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label="Yili"
                        help="Avtomobil ishlab chiqarilgan yili"
                      />
                    }
                    name="vehicleYear"
                    rules={[{ required: true, message: "Yilni kiriting" }]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      min={2000}
                      max={2030}
                      placeholder="2020"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label="Rangi"
                        help="Avtomobil rangi. O'zbek tilida kiriting."
                      />
                    }
                    name="vehicleColor"
                    rules={[{ required: true, message: "Rangni kiriting" }]}
                  >
                    <Input placeholder="Oq" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Davlat raqami"
                    help="Avtomobil davlat raqami. Masalan: 01A123AA"
                  />
                }
                name="vehiclePlate"
                rules={[{ required: true, message: "Raqamni kiriting" }]}
              >
                <Input placeholder="01A123AA" style={{ textTransform: 'uppercase' }} />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="O'rindiqlar soni"
                    help="Avtomobilda yo'lovchilar uchun o'rindiqlar soni (haydovchidan tashqari)"
                  />
                }
                name="vehicleSeats"
                initialValue={4}
              >
                <InputNumber style={{ width: '100%' }} min={2} max={8} placeholder="4" />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
